import styled, { css } from 'styled-components';

type sizes = 'x1' | 'x2' | 'x3';

export const Wrapper = styled.div<{ $fullWidth: boolean }>`
  padding: 0 2px;
  ${({ $fullWidth }) =>
    $fullWidth
      ? css`
          width: 100%;
        `
      : null}
`;

export const Label = styled.label`
  color: ${({ theme }) => theme.palette.lightText};
  font-size: ${({ theme }) => theme.fs.xs};
  position: relative;
  display: flex;
  align-items: flex-start;
`;
export const ButtonFileb = styled.div`
  margin-inline-end: ${({ theme }) => theme.spacing.x2};
`;
export const FileName = styled.p`
  font-size: 10px;
  margin-inline-start: 10px;
`;
export const Required = styled.div`
  position: relative;
  top: -50%;
  color: ${({ theme }) => theme.palette.red};
`;

export const FieldWrapper = styled.div<{ $disabled: boolean }>`
  display: flex;
  align-items: center;
  width: 100%;
  background: ${({ $disabled, theme }) => ($disabled ? 'rgba(31,44,81,.05)' : theme.palette.white)};
  border: 1px solid ${({ theme }) => theme.palette.border};
  border-radius: ${({ theme }) => theme.rounded.x1};
  position: relative;
  transition: 0.1s;
  &:focus-within {
    border-color: ${({ theme }) => theme.palette.primary};
  }
`;

export const Input = styled.input<{ $size?: sizes; $type?: string }>`
  width: 100%;
  outline: none;
  border: none;
  padding: ${({ theme }) => theme.spacing.x2};
  background: transparent;

  ${({ $type }) => css`
    ${$type === 'file' &&
    css`
      padding: ${({ theme }) => theme.spacing.x2};
      font-size: 10px;
      display: none;
      &::before {
        display: none;
      }
      &::file-selector-button {
        display: none;
      }
    `}
  `}

  ${({ $size }) => css`
    ${$size === 'x1'
      ? css`
          height: ${({ theme }) => theme.spacing.x9};
        `
      : $size === 'x2'
      ? css`
          height: ${({ theme }) => theme.spacing.x10};
        `
      : $size === 'x3'
      ? css`
          height: ${({ theme }) => theme.spacing.x12};
        `
      : css`
          height: ${({ theme }) => theme.spacing.x10};
        `}
  `}

  &::placeholder {
    color: ${({ theme }) => theme.palette.lightGray};
  }
`;

export const Textarea = styled.textarea`
  width: 100%;
  outline: none;
  border: none;
  padding: ${({ theme }) => theme.spacing.x1};
  resize: none;
  background: transparent;
`;

export const AdditionalIcon = styled.div<{ $size?: sizes }>`
  ${({ $size, theme }) => css`
    padding: ${theme.spacing.x1};
    display: flex;
    align-items: center;
    justify-content: center;
    ${$size === 'x1'
      ? css`
          height: ${({ theme }) => theme.spacing.x9};
          width: ${({ theme }) => theme.spacing.x9};
        `
      : $size === 'x2'
      ? css`
          height: ${({ theme }) => theme.spacing.x10};
          width: ${({ theme }) => theme.spacing.x10};
        `
      : $size === 'x3'
      ? css`
          width: ${({ theme }) => theme.spacing.x12};
          height: ${({ theme }) => theme.spacing.x12};
        `
      : css`
          width: ${({ theme }) => theme.spacing.x10};
          height: ${({ theme }) => theme.spacing.x10};
        `}
  `}
`;

export const PrependIcon = styled(AdditionalIcon)`
  margin-inline-end: ${({ theme }) => theme.spacing.x3};
`;
export const AppendIcon = styled(AdditionalIcon)`
  margin-inline-start: ${({ theme }) => theme.spacing.x3};
`;

export const Message = styled.span<{ $error?: Boolean }>`
  font-size: ${({ theme }) => theme.fs.xs};
  padding-top: ${({ theme }) => theme.spacing.x1};
  ${({ $error, theme }) => css`
    color: ${$error ? theme.palette.error : theme.palette.lightGray};
  `}
`;
